import React, { useState, useEffect } from "react";
import "./doctorForm.scss";
import { MdOutlineMail } from "react-icons/md";
import { IoCallOutline, IoLocationOutline } from "react-icons/io5";
import { Helmet } from "react-helmet";
import ContactForm from "../../components/contactcomp/ContactForm";
import { getCountryPhoneDetails } from "../../utils/countryUtils";

function DoctorForm() {
  const [phoneDetails, setPhoneDetails] = useState({ number: '', flag: '' });

  useEffect(() => {
    const fetchCountryDetails = async () => {
      const details = await getCountryPhoneDetails();
      setPhoneDetails(details);
    };
    
    fetchCountryDetails();
  }, []);

  return (
    <>
      <Helmet>
        <title>Join AxonCare Network: For Healthcare Professionals</title>
        <meta
          name="description"
          content="Join AxonCare's global network of healthcare professionals. Apply to become part of our team and help revolutionize virtual healthcare."
        />
        <meta
          name="keywords"
          content="AxonCare, doctor network, healthcare professionals, join healthcare network, specialist doctors, medical network"
        />
      </Helmet>
      <div className="contact-parent parent">
        <div className="contact-container container">
          <div className="contact-left contact-body">
            <div className="contact-card">
              <div className="heading custom-heading">Join Our Network</div>
              <p className="doctor-intro">
                AxonCare is expanding its global network of healthcare professionals. Join us in our mission to make quality healthcare accessible to everyone, everywhere.
              </p>
              <p className="doctor-benefits">
                <strong>Benefits of joining:</strong>
              </p>
              <ul className="benefits-list">
                <li>Access to global patients</li>
                <li>Flexible working hours</li>
                <li>Advanced AI-powered diagnostic tools</li>
                <li>Seamless patient record management</li>
                <li>Competitive compensation</li>
              </ul>
            </div>
            <div className="contact-card">
              <a href="tel:+14086936337​" className="contact-card-box">
                <span>
                  <IoCallOutline />
                </span>
                <div className="contact-info">
                  <div className="heading custom-heading">Call us:</div>
                  <p>{phoneDetails.number} {phoneDetails.flag}</p>
                </div>
              </a>
              <a
                href="mailto:support@axoncare.io"
                className="contact-card-box"
              >
                <span>
                  <MdOutlineMail />
                </span>
                <div className="contact-info">
                  <div className="heading custom-heading">Email us:</div>
                  <p>support@axoncare.io</p>
                </div>
              </a>
            </div>
          </div>
          <div className="contact-right contact-body">
            <div>
              <ContactForm
                heading="Doctor/Consultant Application"
                description="Please fill out the form below to join our network of healthcare professionals."
                formType="doctor"
                fields={[
                  { name: "fullName", label: "Full Name", type: "text", required: true },
                  { name: "contactNumber", label: "Contact Number", type: "tel", required: true },
                  { name: "email", label: "Email Address", type: "email", required: true },
                  { name: "specialty", label: "Specialty (if applicable)", type: "text", required: false },
                  { name: "message", label: "Message", type: "textarea", required: true }
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DoctorForm; 